<template>
  <div
    id="teams-view"
    class="pa-4"
  >
    <view-page-header :show-team-select="false" />
    <section>
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <div class="subtitle-2">
            {{ $t('table_title.list_of_all_teams') }}
          </div>
        </v-card-title>
        <v-card-text class="pa-0">
          <teams-list-table
            :teams="teams.data"
            :loading="teams.loading"
            :pagination="teams.pagination"
            @refresh="fetchTeamsList()"
          />
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import TeamsListTable from '@/components/teams/TeamsListTable'
import { TeamApiService } from '@/data/services'
import debounce from 'lodash/debounce'
import ViewPageHeader from '@/components/ViewPageHeader'
import { EventBus } from '@/plugins/bus'
import { reactive } from '@vue/composition-api'

export default {
  name: 'AdminTeamsView',
  components: { ViewPageHeader, TeamsListTable },
  setup(props) {
    const teams = reactive({
      data: [],
      loading: false,
      pagination: {
        current_page: 1,
        last_page: undefined,
        per_page: 25
      }
    })

    const fetchTeamsList = debounce(async function() {
      try {
        teams.loading = true

        const queryParams = {
          page: teams.pagination.current_page,
          per_page: teams.pagination.per_page,
          team_id: this.currentTeamId === 'all' ? undefined : this.currentTeamId
        }

        const resp = await TeamApiService.getPaginated(queryParams)

        resp.data.forEach((team) => {
          for (const zone of Object.keys(team.speed_profile)) {
            team.speed_profile[zone].lower = (team.speed_profile[zone].lower * 3.6).toFixed(1)
            team.speed_profile[zone].upper = (team.speed_profile[zone].upper * 3.6).toFixed(1)
          }
        })

        teams.data = resp.data
        teams.pagination = resp.meta
      } catch (e) {
        teams.data = []
        teams.pagination.current_page = 1
        teams.pagination.last_page = 1
      } finally {
        teams.loading = false
      }
    }, 500)

    return {
      teams,
      fetchTeamsList
    }
  },
  watch: {
    'teams.pagination.current_page': function (newVal, oldVal) {
      this.fetchTeamsList()
    }
  },
  created() {
    this.teams.loading = true

    this.fetchTeamsList()

    EventBus.$on(this.$events.TEAM_CREATED, () => this.fetchTeamsList())
    EventBus.$on(this.$events.TEAM_UPDATED, () => this.fetchTeamsList())
    EventBus.$on(this.$events.TEAM_DELETED, () => this.fetchTeamsList())
  }
}
</script>
